import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const Congratulations = ({ show, onClose, modelRefData }) => {
  const getResponseMessagesByHeader = (header_id) => {
    return modelRefData?.Table1?.filter(m => m.header_id === header_id) || [];
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {modelRefData ? (
          modelRefData.Table?.map((data, index) => (
            <div key={index} style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 500, fontSize: 20, color: '#4B4B5A', marginBottom: 4 }}>
                {data.message}
              </div>
              <ul style={{ marginLeft: 20, marginBottom: 0 }}>
                {getResponseMessagesByHeader(data.header_id).map((detail, detailIndex) => (
                  <li
                    key={detailIndex}
                    style={{
                      fontSize: 16,
                      color: '#4B4B5A',
                      marginBottom: 2,
                      whiteSpace: 'normal',
                      fontWeight: 400
                    }}
                  >
                    {detail.message}
                  </li>
                ))}
              </ul>
            </div>
          ))
        ) : (
          <p>Vitals Saved Successfully.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose} >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Congratulations;